module.exports = __webpack_public_path__ + "img/galleria8.31ad58f9.jpg";